<template>
	<base-row>
		<h1 class="page-header">
			<slot />
		</h1>
	</base-row>	

</template>
<script>
import BaseRow from "../layout/BaseRow.vue";

export default {
	components: {BaseRow}
}
</script>